import React, { useEffect } from 'react';
import Layout from '../components/Layout';
// import MainMenu from '../components/MainMenu.jsx';

function SizeGuide() {
  // Scroll to top once on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // ------ Data from the PDF ------
  const bottoms = [
    { size: 'XS', eu: '1', uk: '4-6',  hipsIn: '30 - 32', hipsCm: '76 - 81',  lowHipsIn: '34 - 36', lowHipsCm: '86 - 91',  waistIn: '24 - 25', waistCm: '61 - 64' },
    { size: 'S',  eu: '2', uk: '8-10', hipsIn: '32 - 34', hipsCm: '81 - 86',  lowHipsIn: '36 - 38', lowHipsCm: '91 - 96',  waistIn: '26 - 28', waistCm: '66 - 71' },
    { size: 'M',  eu: '3', uk: '10-12',hipsIn: '35 - 37', hipsCm: '89 - 94',  lowHipsIn: '38 - 40', lowHipsCm: '96 - 101', waistIn: '28 - 30', waistCm: '71 - 76' },
    { size: 'L',  eu: '4', uk: '12-14',hipsIn: '38 - 40', hipsCm: '97 - 102', lowHipsIn: '40 - 42', lowHipsCm: '101 - 106',waistIn: '30 - 33', waistCm: '76 - 84' },
    { size: 'XL', eu: '5', uk: '16-18',hipsIn: '42 - 44', hipsCm: '106 - 112',lowHipsIn: '44 - 46', lowHipsCm: '112 - 117',waistIn: '33 - 36', waistCm: '84 - 91' },
  ];

  const tops = [
    { size: 'XS', cup: 'AA - A', backIn: '26 - 28', backCm: '66 - 71' },
    { size: 'S',  cup: 'A - B',  backIn: '28 - 30', backCm: '71 - 76' },
    { size: 'M',  cup: 'B - C',  backIn: '30 - 32', backCm: '76 - 81' },
    { size: 'L',  cup: 'C - D',  backIn: '32 - 36', backCm: '81 - 91' },
    { size: 'XL', cup: 'D - DD', backIn: '34 - 38', backCm: '86 - 96' },
  ];

  // Laid flat, measured in CM
  const trousers = [
    { label: 'Waist',            values: ['35', '38', '42'] },
    { label: 'Waist stretched',  values: ['43', '46', '50'] },
    { label: 'Outside leg',      values: ['97', '103', '103'] },
    { label: 'Inside leg',       values: ['74', '80', '76'] },
    { label: 'Width at knee',    values: ['30', '30', '32'] },
    { label: 'Hem space*',       values: ['5',  '7',  '7']  },
  ];

  const denimShirt = [
    { label: 'Armpit to armpit',         values: ['48', '55', '62'] },
    { label: 'Shoulder to shoulder',     values: ['40', '45', '52'] },
    { label: 'Shoulder to cuff',         values: ['60', '61', '64'] },
    { label: 'Cuff',                      values: ['16', '16', '17'] },
    { label: 'Hem',                      values: ['50', '56', '61'] },
    { label: 'Back of collar to hem',    values: ['58', '64', '71'] },
  ];

  const pinstripeShirt = [
    { label: 'Armpit to armpit',         values: ['52', '54', '56'] },
    { label: 'Shoulder to shoulder',     values: ['40', '43', '44'] },
    { label: 'Shoulder to cuff',         values: ['64', '64', '64'] },
    { label: 'Cuff',                      values: ['14', '16', '16'] },
    { label: 'Hem',                      values: ['53', '61', '65'] },
    { label: 'Back of collar to hem',    values: ['69', '71', '74'] },
  ];
  // --------------------------------------

  return (
    <Layout>
      {/* <MainMenu /> */}
      <div className="container mx-auto py-0 px-4 w-full md:w-[69%] text-center mt-12">
        <h1 className="text-3xl italic mb-8">Size Guide</h1>

        <p className="mb-4 italic">
          Please note that these are recommended average measurements, but we are aware that we come in all shapes and sizes. If you would like some help in figuring out the perfect fit please go to the contact section of our website.
        </p>

        {/* Bottoms */}
        <h2 className="text-lg uppercase">Knickers &amp; Bikini Bottoms</h2>
        <div className="overflow-x-auto mb-4">
          <table className="min-w-full table-fixed bg-white shadow-md rounded-lg border">
            <thead>
              <tr className="bg-white uppercase">
                <th className="px-4 py-2 border whitespace-nowrap min-w-[80px]">Size</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[90px]">EU Size</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[90px]">UK Size</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[120px]">Hips (Inches)</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[110px]">Hips (CM)</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[140px]">Low Hips (Inches)</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[120px]">Low Hips (CM)</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[130px]">Waist (Inches)</th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[110px]">Waist (CM)</th>
              </tr>
            </thead>
            <tbody>
              {bottoms.map((r) => (
                <tr key={r.size}>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[80px]">{r.size}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[90px]">{r.eu}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[90px]">{r.uk}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[120px]">{r.hipsIn}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[110px]">{r.hipsCm}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[140px]">{r.lowHipsIn}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[120px]">{r.lowHipsCm}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[130px]">{r.waistIn}</td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[110px]">{r.waistCm}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mb-8 italic">
          For hips measurement, pass the measuring tape around your hips in line with your hip bones. For low hips measurement, pass the measuring tape around the fullest part of your bottom, in line with your pelvic bone.
        </p>

        {/* Tops */}
        <h2 className="text-lg uppercase">Bras &amp; Bikini Tops</h2>
        <div className="overflow-x-auto mb-4">
          <table className="min-w-full table-auto bg-white shadow-md rounded-lg border">
            <thead>
              <tr className="bg-white uppercase">
                <th className="px-4 py-2 border whitespace-nowrap min-w-[80px]">
                  Size
                </th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[110px]">
                  Cup Size
                </th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[150px]">
                  Back Size (Inches)
                </th>
                <th className="px-4 py-2 border whitespace-nowrap min-w-[130px]">
                  Back Size (CM)
                </th>
              </tr>
            </thead>
            <tbody>
              {tops.map((r) => (
                <tr key={r.size}>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[80px]">
                    {r.size}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[110px]">
                    {r.cup}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[150px]">
                    {r.backIn}
                  </td>
                  <td className="border px-4 py-2 whitespace-nowrap min-w-[130px]">
                    {r.backCm}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <p className="mb-8 italic">
          For back size measurement, pass the tape measure around your back below your bust.
        </p>

        {/* Trousers */}
        <h2 className="text-lg uppercase">
          Trousers <br/><span className="text-sm lowercase italic font-normal">(laid flat, measured in CM)</span>
        </h2>
        <div className="overflow-x-auto mb-4">
          {(() => {
            // Build headers from measurement labels, and rows from sizes
            const sizeLabels = ["Small", "Medium", "Large"];
            const measurementHeaders = trousers.map((row) => row.label);
            const transposedRows = sizeLabels.map((size, idx) => ({
              size,
              values: trousers.map((row) => row.values[idx] ?? ""),
            }));

            return (
              <table className="min-w-full table-auto bg-white rounded-lg border">
                <thead>
                  <tr className="bg-white uppercase">
                    <th className="px-4 py-2 border">Size</th>
                    {measurementHeaders.map((h) => (
                      <th key={h} className="px-4 py-2 border">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transposedRows.map((r) => (
                    <tr key={r.size}>
                      <td className="border px-4 py-2 uppercase">{r.size}</td>
                      {r.values.map((v, i) => (
                        <td key={`${r.size}-${i}`} className="border px-4 py-2">{v}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
          <p className="text-sm italic mt-2">
            * distance between the bottom of the print and the hem. Can be tailored shorter without spoiling the design.
          </p>
        </div>

        {/* Denim Shirt */}
        <h2 className="text-lg uppercase">
          Denim Shirt <br/>
          <span className="text-sm lowercase italic font-normal">(laid flat, measured in CM)</span>
        </h2>
        <div className="overflow-x-auto mb-4">
          {(() => {
            const sizeLabels = ["Small", "Medium", "Large"];
            const measurementHeaders = denimShirt.map(row => row.label);
            const transposedRows = sizeLabels.map((size, idx) => ({
              size,
              values: denimShirt.map(row => row.values[idx] ?? ""),
            }));

            return (
              <table className="min-w-full table-auto bg-white shadow-md rounded-lg border">
                <thead>
                  <tr className="bg-white uppercase">
                    <th className="px-4 py-2 border">Size</th>
                    {measurementHeaders.map(h => (
                      <th key={h} className="px-4 py-2 border">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transposedRows.map(r => (
                    <tr key={r.size} className="uppercase">
                      <td className="border px-4 py-2">{r.size}</td>
                      {r.values.map((v, i) => (
                        <td key={`${r.size}-${i}`} className="border px-4 py-2">{v}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
        </div>


        {/* Pinstripe Shirt */}
        <h2 className="text-lg uppercase">
          Pinstripe Shirt <br/>
          <span className="text-sm lowercase italic font-normal">(laid flat, measured in CM)</span>
        </h2>
        <div className="overflow-x-auto">
          {(() => {
            const sizeLabels = ["Small", "Medium", "Large"];
            const measurementHeaders = pinstripeShirt.map(row => row.label);
            const transposedRows = sizeLabels.map((size, idx) => ({
              size,
              values: pinstripeShirt.map(row => row.values[idx] ?? ""),
            }));

            return (
              <table className="min-w-full table-auto bg-white shadow-md rounded-lg border">
                <thead>
                  <tr className="bg-white uppercase">
                    <th className="px-4 py-2 border">Size</th>
                    {measurementHeaders.map(h => (
                      <th key={h} className="px-4 py-2 border">{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {transposedRows.map(r => (
                    <tr key={r.size} className="uppercase">
                      <td className="border px-4 py-2">{r.size}</td>
                      {r.values.map((v, i) => (
                        <td key={`${r.size}-${i}`} className="border px-4 py-2">{v}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            );
          })()}
        </div>


      </div>
    </Layout>
  );
}

export default SizeGuide;
